import { TRecentlyViewedOffer } from '../../types/recentlyViewedOffer';
import { ITypedReduxAction } from '../../types/redux/actionType';

export enum EOffersFromHistoryActionTypes {
  Set = 'offersFromHistory/set',
  ToggleFavorite = 'offersFromHistory/toggleFavorite',
}

export interface IOffersFromHistoryPayload {
  data: TRecentlyViewedOffer[];
}

export interface IOffersFromHistoryToggleFavoritePayload {
  offerId: number;
  isFavorite: boolean;
}

export type TOffersFromHistorySet = ITypedReduxAction<EOffersFromHistoryActionTypes.Set, IOffersFromHistoryPayload>;
export type TOffersFromHistoryToggleFavorite = ITypedReduxAction<
  EOffersFromHistoryActionTypes.ToggleFavorite,
  IOffersFromHistoryToggleFavoritePayload
>;

export type TOffersFromHistoryActions = TOffersFromHistorySet | TOffersFromHistoryToggleFavorite;
